import dayjs from 'dayjs';
import type { DateRange } from 'react-day-picker';

interface RangeHintProps {
  range: DateRange | undefined;
  minRangeDays?: number;
  maxRangeDays?: number;
  className?: string;
}

const RangeHint = ({ range, minRangeDays, maxRangeDays, className = '' }: RangeHintProps) => {
  if (!minRangeDays || !maxRangeDays) return null;

  const days = range?.from ? dayjs(range.to ?? range.from).diff(range.from, 'day') + 1 : 0;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="whitespace-nowrap text-[14px] text-cds-coolgray-80">
        총 <span className="font-semibold text-cds-orange-50">{days}</span>일
      </span>
      <span className="rounded-[6px] bg-cds-coolgray-10 px-1.5 py-1 text-[12px] text-cds-coolgray-55">
        최소 {minRangeDays}일부터 최대 {maxRangeDays}일까지 선택 가능
      </span>
    </div>
  );
};

export default RangeHint;
